import { useCallback } from "react";


import toast from "react-hot-toast";

import { useOrgServicesListAPI } from "../org/useOrgServicesListAPI";


import { useUserRoleAPI } from "../user/useUserRoleAPI";

export const useSetStaticAPIData = () => {
  // const fetchBreeds = usePetBreedsAPI();
  // const fetchPetSpecies = usePetSpeciesAPI();
  // const fetchGenders = usePetGendersAPI();
  // const fetchPetMoods = usePetMoodsAPI();
  
  // const fetchPetStatus = usePetStatusAPI();
  // const fetchAddressLabels = useAddressLabelsAPI();
  // const fetchOrgBookingStatuses = useBookingStatusListAPI();
  const fetchUserRoles = useUserRoleAPI();
  const fetchOrgServices = useOrgServicesListAPI();
  // const fetchOrgProviders = useOrgClinicProvidersAPI();
  

  const execute = useCallback(async () => {
    try {
      await fetchUserRoles().then(async () => {
        await fetchOrgServices();
      });
    } catch {
      toast.error("Static API fetch error");
    }
  }, []);

  return execute;
};
